import React, { useEffect, useState } from 'react'
import { Col, Row, Table } from 'react-bootstrap'
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { CSVLink } from 'react-csv'
import { fetchReportGoals } from '../../../services/httpClient';
import ReactPaginate from 'react-paginate'
import IconEmbeddedButton from '../../ui/IconEmbeddedButton';

interface GoalsCompletedTableState {
  data?: any[];
  startDate?: string;
  endDate?: string;
  useDatePicker?: boolean;
}

export const GoalsCompletedTable = ({ data, startDate, endDate, useDatePicker = false }: GoalsCompletedTableState) => {
  const [goalData, setGoalData] = useState<any>([]);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;
  const pageCount = Math.ceil(goalData.length / itemsPerPage);
  const offset = currentPage * itemsPerPage;
  const currentData = goalData.slice(offset, offset + itemsPerPage);

  useEffect(() => {
    const fetchData = async () => {
      if (data || data === 0) {
        setGoalData(data as any[]);
      } else {
        const starting = new Date();
        starting.setDate(starting.getDate() - 365);
        let start = starting.toISOString().slice(0, 10);
        let end = new Date().toISOString().slice(0, 10);
        if (useDatePicker) {
          start = startDate ?? start;
          end = endDate ?? end;
        }
        await getGoalData(start!, end!);
      }
    }
    fetchData();
  }, [data, startDate, endDate, useDatePicker]);

  const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hour = String(now.getHours()).padStart(2, "0");
    const minute = String(now.getMinutes()).padStart(2, "0");
    const second = String(now.getSeconds()).padStart(2, "0");
    return `${year}${month}${day}${hour}${minute}${second}`;
  };

  const getGoalData = async (start: string, end: string) => {
    fetchReportGoals(start, end)
      .then((res: any) => {
        const goals = res[0].data;
        const sortedGoals = goals.sort((a: any, b: any) => (a.completed_at < b.completed_at ? 1 : -1));
        setGoalData(sortedGoals);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  const goalHeaders = [
    { label: "ID", key: "id" },
    { label: "Goal Name", key: "goal_name" },
    { label: "Completed Date", key: "completed_at" },
    { label: "Case ID", key: "case_id" },
    { label: "Case Name", key: "case_name" },
    { label: "Assigned To", key: "subject.name" },
  ];

  return (
    <>
      <Row>
        <Col>
          <h5 className="app-header-text">Goals Completed</h5>
        </Col>
        <Col className="text-end">
          {data && (
            <CSVLink
              id="download-goals-button"
              data={goalData}
              headers={goalHeaders}
              filename={`goals${getCurrentDateTime()}.csv`}
              style={{ display: "inline-block" }}
              target="_blank"
            >
              <IconEmbeddedButton tooltipText="Data Export" icon={faDownload} />
            </CSVLink>
          )}
        </Col>
      </Row>
      <Row className="mb-3">
        <Col className="col-12">
          <Table striped>
            <thead>
              <tr>
                <th>Case Name</th>
                <th>Assigned To</th>
                <th>Goal</th>
                <th>Completed</th>
              </tr>
            </thead>
            <tbody>
              {currentData?.map((d: any) => (
                <tr key={d.id}>
                  <td>{d.case_name}</td>
                  <td>{d.subject?.name}</td>
                  <td>{d.goal_name}</td>
                  <td className="text-nowrap">{d.completed_at}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          {pageCount > 1 && (
            <div id="goals-pagination" style={{ position: 'relative', zIndex: 0 }}>
              <ReactPaginate
                previousLabel={"← Previous"}
                nextLabel={"Next →"}
                pageCount={pageCount}
                onPageChange={(event: { selected: number }) => setCurrentPage(event.selected)}
                containerClassName={"pagination justify-content-center"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextClassName={"page-item"}
                nextLinkClassName={"page-link"}
                activeClassName={"active"}
                forcePage={currentPage}
              />
            </div>
          )}
        </Col>
      </Row>
    </>
  );
};
